import { render, staticRenderFns } from "./malfunctionList.vue?vue&type=template&id=8fa9b0c6&scoped=true"
import script from "./malfunctionList.vue?vue&type=script&lang=js"
export * from "./malfunctionList.vue?vue&type=script&lang=js"
import style0 from "./malfunctionList.vue?vue&type=style&index=0&id=8fa9b0c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa9b0c6",
  null
  
)

export default component.exports